import {Link, CircularProgress} from '@material-ui/core';
import {ButtonProps} from '@material-ui/core/Button';
import {createSnackbar} from 'Core/ducks/snackbar';
import {ServerError, AsyncError} from 'Core/models/Async';
import React, {ReactNode, useState} from 'react';
import {useDispatch} from 'react-redux';
import 'Shared/components/FileDownloadLink.sass';
import {downloadFile} from 'Shared/utilities/fetchHelpers';

type FileDownloadLinkProps = {
  downloadedFileName: string;
  extension?: FileExtension;
  relativeFileLocation: string;
  children: ReactNode;
  className?: string;
} & ButtonProps;

export enum FileExtension {
  XLSX = '.xlsx',
  TIFF = '.tiff',
  PDF = '.pdf',
  CSV = '.csv',
  XLS = '.xls',
  MSG = '.msg',
  EML = '.eml',
}

const FileDownloadLink = (props: FileDownloadLinkProps) => {
  const {downloadedFileName, extension = '', relativeFileLocation, className, children} = props;
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  return isLoading ? (
    <CircularProgress className="file-download-link__loading" />
  ) : (
    <Link
      className={className}
      color="primary"
      onClick={() => {
        downloadFile(relativeFileLocation, `${downloadedFileName}${extension}`)
          .then((response: AsyncError | string) => {
            if (typeof response === 'string') {
              dispatch(createSnackbar(response));
            } else {
              if (response instanceof ServerError)
                dispatch(createSnackbar('An Error Occurred While Downloading the Enrollment File.'));
              else dispatch(createSnackbar(response.message));
            }
          })
          .then(() => {
            setIsLoading(false);
          });

        setIsLoading(true);
      }}
    >
      {children}
    </Link>
  );
};

export default FileDownloadLink;
